// 看板思考模式：不同文稿类型的结构框架。
// 每列 from = 基础阶段（inspiration/draft/polish/done），拖入列时把卡片写回 from[0]。
export const BOARD_MODES = [
  {
    id: 'flow',
    label: '流程看板',
    en: 'FLOW',
    description: '灵感 → 草稿 → 打磨 → 落定：写作的默认四阶段。',
    recommendFor: [],
    columns: [
      { id: 'inspiration', label: '灵感', en: 'INSPIRATION', color: '#c8b27e', from: ['inspiration'] },
      { id: 'draft', label: '草稿', en: 'DRAFT', color: '#8fa58b', from: ['draft'] },
      { id: 'polish', label: '打磨', en: 'POLISH', color: '#8b9cb5', from: ['polish'] },
      { id: 'done', label: '落定', en: 'DONE', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'narrative',
    label: '三幕结构',
    en: 'THREE ACTS',
    description: '第一幕建立人物与目标，第二幕施加对抗与危机，第三幕解决并留下余味。适合小说与剧本。',
    recommendFor: ['小说'],
    columns: [
      { id: 'setup', label: '第一幕 · 建制', en: 'SETUP', color: '#c8b27e', from: ['inspiration'] },
      { id: 'confrontation', label: '第二幕 · 对抗', en: 'CONFRONTATION', color: '#b0815f', from: ['draft', 'polish'] },
      { id: 'resolution', label: '第三幕 · 解决', en: 'RESOLUTION', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'hero',
    label: '英雄之旅',
    en: 'HERO JOURNEY',
    description: '启程（召唤与导师）→ 考验（伙伴与敌人）→ 深渊与奖赏 → 归来（复活与新生）。适合成长类故事。',
    recommendFor: ['小说'],
    columns: [
      { id: 'departure', label: '启程', en: 'DEPARTURE', color: '#c8b27e', from: ['inspiration'] },
      { id: 'trials', label: '考验', en: 'TRIALS', color: '#b0815f', from: ['draft'] },
      { id: 'abyss', label: '深渊与奖赏', en: 'ABYSS', color: '#8b6f8f', from: ['polish'] },
      { id: 'return', label: '归来', en: 'RETURN', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'beats',
    label: '救猫咪节拍',
    en: 'SAVE THE CAT',
    description: '开场画面 → 催化剂 → 中点 → 一无所有 → 灵魂黑夜 → 结局：商业故事的关键节拍。',
    recommendFor: ['小说'],
    columns: [
      { id: 'opening', label: '设定与催化剂', en: 'OPENING', color: '#c8b27e', from: ['inspiration'] },
      { id: 'midpoint', label: '中点与逼近', en: 'MIDPOINT', color: '#b0815f', from: ['draft'] },
      { id: 'dark', label: '一无所有与黑夜', en: 'DARK NIGHT', color: '#8b6f8f', from: ['polish'] },
      { id: 'finale', label: '结局与终场', en: 'FINALE', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'qicheng',
    label: '起承转合',
    en: 'QI-CHENG-ZHUAN-HE',
    description: '起：引入；承：展开；转：转折或反差；合：收束点题。适合随笔与散文。',
    recommendFor: ['随笔', '私人手记'],
    columns: [
      { id: 'qi', label: '起', en: 'OPENING', color: '#c8b27e', from: ['inspiration'] },
      { id: 'cheng', label: '承', en: 'DEVELOPMENT', color: '#8fa58b', from: ['draft'] },
      { id: 'zhuan', label: '转', en: 'TURN', color: '#8b9cb5', from: ['polish'] },
      { id: 'he', label: '合', en: 'CLOSE', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'imrad',
    label: 'IMRaD 研究',
    en: 'IMRAD',
    description: '研究问题 → 方法 → 证据与结果 → 讨论与结论：论文与研究报告的标准骨架。',
    recommendFor: ['写作研究'],
    columns: [
      { id: 'problem', label: '问题', en: 'INTRODUCTION', color: '#c8b27e', from: ['inspiration'] },
      { id: 'method', label: '方法', en: 'METHOD', color: '#8fa58b', from: ['draft'] },
      { id: 'evidence', label: '证据', en: 'RESULTS', color: '#8b9cb5', from: ['polish'] },
      { id: 'discussion', label: '讨论', en: 'DISCUSSION', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'critique',
    label: '论点检验',
    en: 'CLAIM-CHECK',
    description: '论点 → 反例 → 证据 → 修正后的结论：用于把观点磨成经得起追问的判断。',
    recommendFor: ['写作研究'],
    columns: [
      { id: 'claim', label: '论点', en: 'CLAIM', color: '#c8b27e', from: ['inspiration'] },
      { id: 'counter', label: '反例', en: 'COUNTER', color: '#b0815f', from: ['draft'] },
      { id: 'proof', label: '证据', en: 'EVIDENCE', color: '#8b9cb5', from: ['polish'] },
      { id: 'revised', label: '修正结论', en: 'REVISED', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'solve',
    label: '问题解决',
    en: 'PROBLEM-SOLVE',
    description: '定义问题 → 提出方案 → 验证取舍 → 落地执行：适用于方案、计划与说明类文稿。',
    recommendFor: ['写作研究', '随笔'],
    columns: [
      { id: 'define', label: '定义问题', en: 'DEFINE', color: '#c8b27e', from: ['inspiration'] },
      { id: 'options', label: '提出方案', en: 'OPTIONS', color: '#8fa58b', from: ['draft'] },
      { id: 'verify', label: '验证取舍', en: 'VERIFY', color: '#8b9cb5', from: ['polish'] },
      { id: 'execute', label: '落地执行', en: 'EXECUTE', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'fiveact',
    label: '五幕结构',
    en: 'FIVE ACTS',
    description: '第一幕建置 → 第二幕上升行动 → 第三幕危机 → 第四幕下行 → 第五幕结局。适合中长篇的戏剧式骨架。',
    recommendFor: ['小说'],
    columns: [
      { id: 'act1', label: '第一幕 · 建置', en: 'ACT I', color: '#c8b27e', from: ['inspiration'] },
      { id: 'act2', label: '第二幕 · 上升', en: 'ACT II', color: '#8fa58b', from: ['draft'] },
      { id: 'act3', label: '第三幕 · 危机', en: 'ACT III', color: '#b0815f', from: ['polish'] },
      { id: 'act4', label: '第四幕 · 下行', en: 'ACT IV', color: '#8b6f8f', from: ['polish'] },
      { id: 'act5', label: '第五幕 · 结局', en: 'ACT V', color: '#6f7d72', from: ['done'] },
    ],
  },
  {
    id: 'hierarchy',
    label: '长篇结构',
    en: 'ACT-CHAPTER',
    description: '幕 → 章 → 段 三级结构：卡片按“第X幕”归列，卡片详情里可标章号和段号。适合长篇。',
    recommendFor: ['小说'],
    columns: [
      { id: 'act1', label: '第一幕', en: 'ACT I', color: '#c8b27e', from: ['inspiration'], actKeys: ['第一幕', '序幕'] },
      { id: 'act2', label: '第二幕', en: 'ACT II', color: '#8fa58b', from: ['draft'], actKeys: ['第二幕'] },
      { id: 'act3', label: '第三幕', en: 'ACT III', color: '#b0815f', from: ['polish'], actKeys: ['第三幕'] },
      { id: 'act4', label: '第四幕', en: 'ACT IV', color: '#8b6f8f', from: ['polish'], actKeys: ['第四幕'] },
      { id: 'act5', label: '第五幕', en: 'ACT V', color: '#6f7d72', from: ['done'], actKeys: ['第五幕', '尾声', '终幕'] },
    ],
  },
]

export function boardModeById(id) {
  return BOARD_MODES.find((mode) => mode.id === id) || BOARD_MODES[0]
}

export const NOVEL_LENGTHS = {
  short: { label: '短篇', range: '3 千 – 3 万字' },
  medium: { label: '中篇', range: '3 万 – 10 万字' },
  long: { label: '长篇', range: '10 万字以上' },
}

export function isNovelType(type) {
  return typeof type === 'string' && (type.includes('小说') || type === '短篇集')
}

export function recommendedModes(projectType, novelLength) {
  if (isNovelType(projectType)) {
    if (novelLength === 'short') return BOARD_MODES.filter((mode) => ['qicheng', 'narrative', 'flow'].includes(mode.id))
    if (novelLength === 'long') return BOARD_MODES.filter((mode) => ['hierarchy', 'fiveact', 'hero', 'narrative'].includes(mode.id))
    return BOARD_MODES.filter((mode) => ['narrative', 'hero', 'beats', 'flow'].includes(mode.id))
  }
  return BOARD_MODES.filter((mode) => mode.recommendFor.includes(projectType))
}

export function assignCardsToColumns(modeDef, cards) {
  const map = new Map()
  if (modeDef.id === 'hierarchy') {
    const columns = modeDef.columns
    for (const card of cards) {
      if (card.column === 'unsorted') { map.set(card.id, '__unsorted__'); continue }
      const act = card.act || ''
      const column = columns.find((item) => (item.actKeys || []).some((key) => act.includes(key))) || columns[0]
      map.set(card.id, column.id)
    }
    return map
  }
  const seen = new Map()
  for (const card of cards) {
    if (card.column === 'unsorted') { map.set(card.id, '__unsorted__'); continue }
    const cols = modeDef.columns.filter((column) => column.from.includes(card.column))
    if (!cols.length) {
      map.set(card.id, modeDef.columns[0].id)
      continue
    }
    const count = seen.get(card.column) || 0
    seen.set(card.column, count + 1)
    map.set(card.id, cols[count % cols.length].id)
  }
  return map
}

export function distributeCards(modeDef, cards) {
  const groups = new Map()
  modeDef.columns.forEach((column) => groups.set(column.id, []))
  const assignment = assignCardsToColumns(modeDef, cards)
  for (const card of cards) {
    groups.get(assignment.get(card.id) || modeDef.columns[0].id).push(card)
  }
  return groups
}

export function columnForCard(modeDef, card) {
  const hit = modeDef.columns.find((column) => column.from.includes(card.column))
  return hit || modeDef.columns[0]
}